import React from "react";

const WidgetsPrecogCard = ({children, className, isEmpty}) => {
  return (
    <div className={`card${isEmpty ? " empty": ""} ${className ? className : ""}`}>
      {
        children
      }
    </div>
  );
};

export default WidgetsPrecogCard;